import axios from "axios";
import React, { useEffect, useState } from "react";
import Header from "./Header";
import "../App.css";

export function Admin() {
  const [bookings, setBookings] = useState([]);
  const [accesGranted, setAccessGranted] = useState(false);
  const [adminPassword, setAdminPassword] = useState("");

  const checkPassword = () => {
    if (adminPassword.toLowerCase() === "odeczek1") {
      setAccessGranted(true);
    }
  };

  useEffect(() => {
    const getBookedSlots = async () => {
      const bookedTimeslots = axios.get(
        "https://little-munchkin-photography.herokuapp.com/api/Timeslots/booked"
      );

      const complete = await Promise.resolve(bookedTimeslots);
      updateBookings(complete);
    };

    const updateBookings = async (props) => {
      setBookings(props.data.response);
    };

    getBookedSlots();

    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Header />
      {accesGranted ? (
        <div>
          {bookings ? (
            <div style={{ textAlign: "center", marginTop: "25px" }}>
              {bookings?.map((booking) => {
                return (
                  <div
                    style={{
                      marginBottom: "15px",
                      border: "1px solid #ccc",
                      borderRadius: "15px",
                      padding: "10px",
                    }}
                  >
                    <div>
                      <div style={{ fontSize: "18px", fontWeight: "600" }}>
                        Booking Date:
                      </div>
                      <div>{booking.name}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: "18px", fontWeight: "600" }}>
                        Customer Name:
                      </div>
                      <div>{booking.customer_name}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: "18px", fontWeight: "600" }}>
                        Number of Children:
                      </div>
                      <div>{booking.number_of_children}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>Loading...</div>
          )}
        </div>
      ) : (
        <div style={{ textAlign: "center", marginTop: "25px" }}>
          <div style={{ display: "flex" }}>
            <div>Enter Admin Password:</div>
            <input
              style={{ fontSize: "16px" }}
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              type="password"
            />
          </div>
          <button
            style={{
              fontSize: "25px",
              borderRadius: "10px",
              marginTop: "15px",
              paddingTop: "5px",
              paddingBottom: "5px",
              color: "white",
              backgroundColor: "gray",
            }}
            onClick={() => checkPassword()}
          >
            ENTER
          </button>
        </div>
      )}
    </div>
  );
}
